import styled from "@emotion/styled"
import { PIcon, PText } from "@porsche-design-system/components-react"
import {
	spacingFluidMd,
	spacingFluidXl,
	spacingStaticSm,
	spacingStaticXs,
} from "@porsche-design-system/components-react/emotion"
import type { NotesView } from "@slfinrtl/ui-bff-routes"
import { defineMessages, FormattedMessage } from "react-intl"
import { Grid, GridItem } from "src/components"

const messages = defineMessages({
	noNotes: {
		defaultMessage: "There are no notes.",
		id: "vehicleDetails.notes.noNotes",
	},
})

interface NotesProps {
	view: NotesView
}

export const Notes = ({ view }: NotesProps) => {
	const { lastChange, value } = view

	return (
		<Grid $columnGap={{ base: spacingFluidMd, s: spacingFluidXl }}>
			<GridItem size={{ base: 12, m: 6 }}>
				{lastChange && (
					<LastChanged>
						<PIcon color="contrast-medium" name="clock" />
						<PText color="contrast-medium">{lastChange}</PText>
					</LastChanged>
				)}
				{value ? (
					<Note>{value}</Note>
				) : (
					<PText color="contrast-medium">
						<FormattedMessage {...messages.noNotes} />
					</PText>
				)}
			</GridItem>
		</Grid>
	)
}

const LastChanged = styled.div`
	display: flex;
	gap: ${spacingStaticXs};
	margin-bottom: ${spacingStaticSm};
`

const Note = styled(PText)`
	white-space: break-spaces;
`
